import { Popover } from "antd";
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { ReactComponent as ICON_TABLE_EDIT } from "@assets/svgs/ICON_TABLE_EDIT.svg";
import { Icon } from "@components/Icon";
import {
  KEY_DEVICE_MANAGEMENT_PROJECT_UPDATE,
  KEY_DEVICE_MANAGEMENT_PROJECT_DELETE,
} from "@static/PERMISSION_KEY";

const SectionTableAction = styled.div`
  display: flex;
  gap: 8px;
`;

const BASE_LOCATION_TABLE_COLUMNS = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    fixed: "left",
    width: 80,
    sorter: (a, b) => a.index - b.index,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    fixed: "left",
  },
  {
    title: "Customer",
    dataIndex: ["categoryCustomer", "customer_name"],
    key: "categoryCustomer",
    width: 280,
    sorter: (a, b) => {
      const nameA = _.get(
        a,
        ["categoryCustomer", "customer_name"],
        ""
      ).toLowerCase();
      const nameB = _.get(
        b,
        ["categoryCustomer", "customer_name"],
        ""
      ).toLowerCase();
      return nameA.localeCompare(nameB);
    },
  },
  {
    title: "Disk limit (GB)",
    dataIndex: "disk_limit",
    key: "disk_limit",
    width: 160,
    align: "end",
    sorter: (a, b) => a.disk_limit - b.disk_limit,
  },
];

export const getLocationTableColumns = ({
  userType,
  permission,
  onHandleEdit,
  onHandleDelete,
  showConfirmation,
}) => {
  const locationColumns =
    userType === "OWNER"
      ? [...BASE_LOCATION_TABLE_COLUMNS]
      : _.filter(BASE_LOCATION_TABLE_COLUMNS, (item) => {
          return _.get(item, ["key"]) !== "categoryCustomer";
        });

  if (userType !== "OWNER") {
    return locationColumns;
  }

  const actionColumn = {
    title: "Actions",
    key: "actions",
    width: 120,
    render: (text, item, index) => (
      <SectionTableAction key={index}>
        {/* {_.includes(permission, KEY_DEVICE_MANAGEMENT_PROJECT_UPDATE) && (
          <Icon
            isCursor
            width={24}
            height={24}
            onClick={() => onHandleEdit({ item })}
          >
            <ICON_TABLE_EDIT />
          </Icon>
        )}
        {_.includes(permission, KEY_DEVICE_MANAGEMENT_PROJECT_DELETE) && (
          <Icon
            isCursor
            width={24}
            height={24}
            onClick={() =>
              showConfirmation({
                onConfirm: () => onHandleDelete({ item }),
              })
            }
          >
            <ICON_TABLE_DELETE />
          </Icon>
        )} */}
        {_.includes(permission, KEY_DEVICE_MANAGEMENT_PROJECT_UPDATE) && (
          <Popover placement="top" trigger="hover" content={<div>Edit</div>}>
            <ICON_TABLE_EDIT
              width={24}
              height={24}
              onClick={() => onHandleEdit({ item })}
            />
          </Popover>
        )}
        {_.includes(permission, KEY_DEVICE_MANAGEMENT_PROJECT_DELETE) && (
          <Popover placement="top" trigger="hover" content={<div>Delete</div>}>
            <ICON_TABLE_DELETE
              width={24}
              height={24}
              onClick={() =>
                showConfirmation({
                  title: "Delete",
                  onConfirm: () => onHandleDelete({ item }),
                })
              }
            />
          </Popover>
        )}
      </SectionTableAction>
    ),
  };

  return [...locationColumns, actionColumn];

  // if (userType === "OWNER") {
  //   return [
  //     ...locationColumns,
  //     {
  //       title: "Actions",
  //       key: "actions",
  //       width: 120,
  //       render: (text, item, index) => {
  //         return (
  //           <SectionTableAction key={index}>
  //             {_.includes(
  //               permission,
  //               KEY_DEVICE_MANAGEMENT_PROJECT_UPDATE
  //             ) && (
  //               <Icon
  //                 isCursor
  //                 width={24}
  //                 height={24}
  //                 onClick={() => onHandleEdit({ item })}
  //               >
  //                 <ICON_TABLE_EDIT />
  //               </Icon>
  //             )}
  //             {!_.get(item, ["is_delete_able"], true) === true ||
  //               (_.includes(
  //                 permission,
  //                 KEY_DEVICE_MANAGEMENT_PROJECT_DELETE
  //               ) && (
  //                 <Icon
  //                   isCursor
  //                   width={24}
  //                   height={24}
  //                   onClick={() =>
  //                     showConfirmation({
  //                       onConfirm: () => onHandleDelete({ item }),
  //                     })
  //                   }
  //                 >
  //                   <ICON_TABLE_DELETE />
  //                 </Icon>
  //               ))}
  //           </SectionTableAction>
  //         );
  //       },
  //     },
  //   ];
  // } else {
  //   return [...locationColumns];
  // }
};
